import { render, staticRenderFns } from "./SynchronizationRules.vue?vue&type=template&id=134d95be&scoped=true"
import script from "./SynchronizationRules.vue?vue&type=script&lang=js"
export * from "./SynchronizationRules.vue?vue&type=script&lang=js"
import style0 from "./SynchronizationRules.vue?vue&type=style&index=0&id=134d95be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d95be",
  null
  
)

export default component.exports